// src/components/data-display/DataTileRealBlockTime.jsx
import { SingleDataValue } from '../data-display';
import { ThemedFlex } from '../../theme/ThemedFlex';

export const DataTileRealBlockTime = ({ data, formatNumber, animate }) => {
  const avgBlockTime = data?.s091?.btc_historical?.Data?.Data?.[1]?.block_time != null
    ? `${formatNumber(data.s091.btc_historical.Data.Data[1].block_time / 60, 1)} Mins`
    : '';

  return (
    <ThemedFlex
      direction="column"
      mb="12px"
      py="18px"
      px="20px"
      flex={1}
      borderRadius={3}
      className={animate ? 'gray-border-custom gray-border' : ''}
    >
      <SingleDataValue label="Avg Blk Time 24h" value={avgBlockTime} />
    </ThemedFlex>
  );
};